import { Stack, Typography } from '@atgfr8/atg-ui-tailwind';
import { v4ServeDocumentUrl } from '@constants/urls';
import { CustomerGeneralDocuments } from '@store/customers/customerDetails';
import { Accessor, Component, For, Show } from 'solid-js';

type CustomerDocumentUploaderProps = {
  documents: Accessor<CustomerGeneralDocuments[]>;
  type: 'Public' | 'Confidential' | 'Misc' | 'Logo';
};

export const CustomerDocumentUploader: Component<
  CustomerDocumentUploaderProps
> = (props) => {
  const getFilteredDoc = () => {
    const { documents, type } = props;
    return documents().filter((doc) => {
      const urlParts = doc.url.split('/');
      if (type === 'Public') {
        return (
          !urlParts.includes('Confidential') &&
          !urlParts.includes('Misc') &&
          !urlParts.includes('Logo')
        );
      }
      return urlParts.includes(type);
    });
  };

  return (
    <Stack spacing={1}>
      <Show
        when={getFilteredDoc().length > 0}
        fallback={<span class="p-[10px]">No document</span>}
      >
        <For each={getFilteredDoc()}>
          {(doc) => (
            <Typography variant="body1" class="p-[10px]">
              <Show when={Boolean(doc.url)} fallback={<span>{doc.name}</span>}>
                <a
                  href={v4ServeDocumentUrl.doc(encodeURIComponent(doc.url))}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-[#1b4960] underline"
                  download={doc.name}
                >
                  {doc.name}
                </a>
              </Show>
            </Typography>
          )}
        </For>
      </Show>
    </Stack>
  );
};
